import React, { useContext } from "react";
import moment from "moment";
import NotificationContext from "../context/notificationContext";

moment.updateLocale("en", {
  calendar: {
    sameElse: "Do MMM YYYY h:mm A",
  },
});

const NotificationList = ({ handleClick }) => {
  const { notifications, handleRead, handleDelete } = useContext(
    NotificationContext
  );

  if (notifications.length === 0)
    return <h5 className="text-center text-muted mt-4">No Notifications</h5>;
  return (
    <div className="list-group">
      {notifications.map((notification) => (
        <div
          key={notification.ID}
          className="list-group-item"
          onClick={(e) => {
            e.stopPropagation();
            handleClick(notification);
          }}
        >
          <div className="d-flex w-100 justify-content-between">
            <p className="h6">
              {notification.HEADING} - {notification.SITE_NAME}
            </p>
            <small className="text-muted">
              {moment(notification.CREATED_DTS).format("ddd Do MMM YYYY h:mma")}
            </small>
          </div>
          <p className="mb-2 text-wrap">{notification.MESSAGE}</p>
          <div className="d-flex w-100 justify-content-between align-items-center">
            <span
              className={
                notification.IS_READ
                  ? "badge badge-info"
                  : "badge badge-warning"
              }
              onClick={(e) => {
                e.stopPropagation();
                handleRead(notification);
              }}
            >
              {notification.IS_READ ? "Read" : "Unread"}
            </span>
            <div>
              <span
                className="badge badge-danger mr-2"
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(notification);
                }}
              >
                <i className="fas fa-trash"></i>
              </span>
              <small>{moment(notification.CREATED_DTS).calendar()}</small>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const NotificationScreen = ({ history }) => {
  const {
    handleRead,
    handleReadAll,
    handleClearAll,
    handleRefresh,
  } = useContext(NotificationContext);

  const handleClick = (notification) => {
    if (!notification.IS_READ) handleRead(notification);
    if (!notification.LINK) return;
    history.push(notification.LINK);
  };

  return (
    <div className="col mt-4">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3 className="m-0">Notifications</h3>
          <div>
            <button className="btn btn-success mr-2" onClick={handleRefresh}>
              <i className="fas fa-redo"></i>
            </button>
            <button className="btn btn-success" onClick={handleReadAll}>
              Mark all as read
            </button>
            <button className="btn btn-danger ml-2" onClick={handleClearAll}>
              Clear All
            </button>
          </div>
        </div>
        <NotificationList handleClick={handleClick} />
      </div>
    </div>
  );
};

export default NotificationScreen;
